import * as React from "react";
import styled, { css } from "styled-components";
import { Link, Spinner } from "components/common";
import usePermissions from "hooks/usePermissions";
import { useStreamMetricsFor } from "components/streams/StreamsOverview/StreamMetricsContext";
import Routes from "routing/Routes";
import recentMessagesTimeRange from "util/TimeRangeHelper";
const StyledLink = styled(Link)(
  ({ theme, $hasFailures }) => css`
    color: ${$hasFailures ? theme.colors.variant.danger : "inherit"};
    font-weight: ${$hasFailures ? "bold" : "normal"};
  `
);
const FAILURES_STREAM_ID = "000000000000000000000004";
const failuresSearchUrl = (streamId) => Routes.stream_search(FAILURES_STREAM_ID, `failed_message_streams:${streamId}`, recentMessagesTimeRange());
const StreamFailureCountCell = ({ stream }) => {
  const { metrics, isInitialLoading, isError } = useStreamMetricsFor(stream.id);
  const { isPermitted } = usePermissions();
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  const failureCount = metrics == null ? void 0 : metrics.failure_count;
  if (isError || typeof failureCount !== "number") {
    return null;
  }
  const title = `${failureCount} failures targeted at this stream in the last 24 hours`;
  const count = /* @__PURE__ */ React.createElement("span", { title }, failureCount);
  if (!isPermitted("searches:relative")) {
    return count;
  }
  return /* @__PURE__ */ React.createElement(
    StyledLink,
    {
      to: failuresSearchUrl(stream.id),
      title: `Search ${title.toLowerCase()}`,
      $hasFailures: failureCount > 0
    },
    count
  );
};
export default StreamFailureCountCell;
